import React, { Component } from "react"
import PropTypes from "prop-types"
import { Row, Col, Card, CardBody } from "reactstrap"
import { Link, withRouter  } from "react-router-dom"
import gridView from "../../../assets/img/grid-view.png"
import engagementView from "../../../assets/img/engagement-view.png"
import statusView from "../../../assets/img/status-view.png"
import typeView from "../../../assets/img/type-view.png"
import groupView from "../../../assets/img/group-view.png"
import stageView from "../../../assets/img/stage-view.png"
import followupView from "../../../assets/img/followup-view.png"

class FilterMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  isActive(path) {
    return this.props.location.pathname === path ? "active" : ""
  }
  render() {
    return (
        <React.Fragment>           
        {/* <Row className="">
          <Col sm="12">
            <div className="">
              <div className="btn-group rl-group-btn" role="group">
                <Link to="/lead/dashboard">
            <button
              type="button"
              className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/dashboard")}`}
            >
              <span className="d-flex align-items-center gap-2">
                
                <span>Active leads</span>

                <img src={gridView} alt="Grid" style={{ height: 16 }} />
              </span>
            </button>
                </Link>
                <Link to="/lead/report/activity-status">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/report/activity-status")}`}
                  >
                     <span className="d-flex align-items-center gap-2">
                    
                   
                    Activity view
                    <img src={engagementView} style={{height:16}} />
                    </span>
                  </button>
                </Link>
                <Link to="/lead/status-view">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/status-view")}`}
                  >
                    <span className="d-flex align-items-center gap-2">
                    
                    
                    Status view
                    <img src={statusView} style={{height:16}} />
                    </span>
                  </button>
                </Link>
                <Link to="/lead/type-view">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/type-view")}`}
                  >
                    <span className="d-flex align-items-center gap-2">
                   
                    
                    Type view
                     <img src={typeView} style={{height:16}} />
                    </span>
                  </button>
                </Link>
                <Link to="/lead/group-view">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/group-view")}`}
                  >
                     <span className="d-flex align-items-center gap-2">
                   
                   
                    Group view

                     <img src={groupView} style={{height:16}} />
                    </span>
                  </button>
                </Link>
                <Link to="/lead/stage-view">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/stage-view")}`}
                  >
                      <span className="d-flex align-items-center gap-2">
                  
                   
                    Stage view

                      <img src={stageView} style={{height:16}} /> 
                     </span>
                  </button>
                </Link>
                <Link to="/lead/timeline-view">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/timeline-view")}`}
                  >
                    <span className="d-flex align-items-center gap-2">
                    
                    
                    Follow-up view
                    <img src={followupView} style={{height:16}} />
                    </span>
                  </button>
                </Link>
              </div>
            </div>     
          </Col>
        </Row> */}

        <Row>
  <Col sm="12">
    <div>
      {/* ✅ Button group for desktop/tablet */}
      <div className="btn-group rl-group-btn d-none d-md-flex" role="group">
        <Link to="/lead/dashboard">
          <button
            type="button"
            className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/dashboard")}`}
          >
            <span className="d-flex align-items-center gap-2">
              <span>Active leads</span>
              <img src={gridView} alt="Grid" style={{ height: 16 }} />
            </span>
          </button>
        </Link>

        <Link to="/lead/report/activity-status">
          <button
            type="button"
            className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/report/activity-status")}`}
          >
            <span className="d-flex align-items-center gap-2">
              Activity view
              <img src={engagementView} style={{ height: 16 }} alt="" />
            </span>
          </button>
        </Link>

        <Link to="/lead/status-view">
          <button
            type="button"
            className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/status-view")}`}
          >
            <span className="d-flex align-items-center gap-2">
              Status view
              <img src={statusView} style={{ height: 16 }} alt="" />
            </span>
          </button>
        </Link>

        <Link to="/lead/type-view">
          <button
            type="button"
            className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/type-view")}`}
          >
            <span className="d-flex align-items-center gap-2">
              Type view
              <img src={typeView} style={{ height: 16 }} alt="" />
            </span>
          </button>
        </Link>

        <Link to="/lead/group-view">
          <button
            type="button"
            className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/group-view")}`}
          >
            <span className="d-flex align-items-center gap-2">
              Group view
              <img src={groupView} style={{ height: 16 }} alt="" />
            </span>
          </button>
        </Link>

        <Link to="/lead/stage-view">
          <button
            type="button"
            className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/stage-view")}`}
          >
            <span className="d-flex align-items-center gap-2">
              Stage view
              <img src={stageView} style={{ height: 16 }} alt="" />
            </span>
          </button>
        </Link>

        <Link to="/lead/timeline-view">
          <button
            type="button"
            className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/lead/timeline-view")}`}
          >
            <span className="d-flex align-items-center gap-2">
              Follow-up view
              <img src={followupView} style={{ height: 16 }} alt="" />
            </span>
          </button>
        </Link>
      </div>

      {/* ✅ Dropdown for mobile */}
      <div className="d-block d-md-none mt-2">
          <label className="form-label fw-bold mb-1">Select View</label>
        <select
          className="form-select"
          value={this.props.location.pathname} // highlight active
          onChange={(e) => this.props.history.push(e.target.value)}
        >
          <option value="/lead/dashboard">Active leads</option>
          <option value="/lead/report/activity-status">Activity view</option>
          <option value="/lead/status-view">Status view</option>
          <option value="/lead/type-view">Type view</option>
          <option value="/lead/group-view">Group view</option>
          <option value="/lead/stage-view">Stage view</option>
          <option value="/lead/timeline-view">Follow-up view</option>
        </select>
      </div>

      
    </div>
  </Col>
</Row>

      </React.Fragment>
    )
  }
}
FilterMenu.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }).isRequired,
    history: PropTypes.object
  }
export default withRouter(FilterMenu)
